module.exports = __webpack_public_path__ + "img/9f67cdf90a58c74a5edc47ca8b46eed.32d00e1f.png";